export default "__VITE_ASSET__981cc692__"